import { _ as _sfc_main } from "./VaAffix.vue_vue_type_script_lang-335870db.mjs";
import { openBlock, createElementBlock, createElementVNode, normalizeStyle, renderSlot, normalizeClass, createCommentVNode } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaAffix_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = {
  ref: "element",
  class: "va-affix"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("div", {
      style: normalizeStyle({ visibility: _ctx.isAffixed ? "hidden" : "inherit" })
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 4),
    _ctx.isAffixed ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(_ctx.computedClass),
      style: normalizeStyle(_ctx.computedStyle)
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 6)) : createCommentVNode("", true)
  ], 512);
}
const _VaAffix = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaAffix as _
};
//# sourceMappingURL=VaAffix-f5212725.mjs.map
